module.exports = __webpack_public_path__ + "static/media/banner-partners.14c9a3a7.jpg";